import { Component, Injectable, OnInit, TemplateRef } from '@angular/core';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap';
import { CqCriteriaService } from '../../../../../common/services/CqCriteria.service';
import { CqCriteriaGroupService } from 'app/common/services/CqCriteriaGroup.service';

declare var $: any;

@Component({
  moduleId: module.id,
  selector: 'cq-criteria',
  templateUrl: './cq_criteria.component.html',
  providers: [CqCriteriaService, BsModalService, CqCriteriaGroupService],
})
@Injectable()
export class CqCriteriaComponent implements OnInit {
  public dtOptions: any = {};
  public dtTrigger: Subject<any> = new Subject();

  public currentPage = 1;
  public totalRow = 0;
  public page_size = 10;
  public message: { class: string; content: string } = null;
  public list: any = [];
  public model: any = {};
  public typeModal: string;
  public modalRef: any = {};
  public modalRef2: any = {};
  public types: any = [];
  totalItem: any = 0;
  totalPage: any = 0;
  public modelFilter: any = {};

  public id_delete: number;
  public user: any = {};
  public is_load_data = false;
  public allCriteriaGroup: any = [];
  public answerValue: any;
  public tileValue: any;
  public demodata: any = [{ value: 'anh tu' }, { value: 'anh tu 1' }, { value: 'anh tu 2' }, { value: 'anh tu 3' }];

  constructor(
    private cqService: CqCriteriaService,
    private cqGroupService: CqCriteriaGroupService,
    private modalService: BsModalService,
    private toastr: ToastrService
  ) {
    this.user = JSON.parse(localStorage.getItem('User'));
  }

  ngOnInit() {
    this.loadData();
    this.getAllCriteriaGroup();
  }

  getAllCriteriaGroup() {
    this.is_load_data = true;
    this.cqGroupService.all().subscribe(res => {
      const criteriaGroupList = [];
      res.data.forEach((c: any) => {
        criteriaGroupList.push({
          text: c.name,
          id: c._id,
        });
      });
      this.allCriteriaGroup = criteriaGroupList;
      this.is_load_data = false;
    });
  }

  changeCriteriaGroup(e: any): void {
    this.model.criteriaGroup = e.value;
  }

  loadData(request: any = {}, sort: any = {}) {
    this.list = [];
    request.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    request.limit = this.page_size;
    if (Object.keys(sort).length == 2) {
      request['sort_by'] = sort.field + ':' + sort.typeSort;
    }

    this.cqService
      .list(request)
      .toPromise()
      .then(
        res => {
          if (res.status == 200 && res.error == false) {
            this.list = res.data.list;
            this.totalItem = res.data.total;
            const pageString = (this.totalItem / this.page_size).toString();
            const pageSplit = pageString.split('.');
            let last: any;
            let totalpage = parseInt(pageSplit[0]);
            if (pageSplit.length > 1) {
              last = pageSplit[1];
              if (parseInt(last) > 0) {
                totalpage++;
              }
            }
            this.totalPage = totalpage;
          } else {
            this.message = {
              class: 'alert dark alert-danger',
              content: res.status + ' : ' + res.message,
            };
            this.list = [];
            // this.genDataTable();
            this.scrollToTop();
          }
        },
        err => {
          this.message = {
            class: 'alert dark alert-danger',
            content: err.message,
          };
          this.list = [];
          // this.genDataTable();
          this.scrollToTop();
        }
      );
  }

  search() {
    this.currentPage = 1;
    if (this.modelFilter.keyword && this.modelFilter.keyword.trim() != '') {
      this.loadData({ name: this.modelFilter.keyword });
    } else {
      this.loadData();
    }
  }

  scrollToTop() {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
  }

  openModal(template: TemplateRef<any>, id?: any) {
    this.message = null;
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
    };
    this.modalRef = this.modalService.show(template, config);

    this.model = {};
    this.typeModal = id ? 'edit' : 'add';
    if (id) {
      this.cqService
        .find(id)
        .toPromise()
        .then(rs => {
          this.model = {
            maxscore: rs.data.maxscore,
            id: rs.data._id,
            desc: rs.data.desc,
            msgdatas: rs.data.msgdesc,
            name: rs.data.name,
            criteriaGroup: rs.data.criteriaGroup,
          };
          console.log(this.model, 'is model');
        });
      // this.list.forEach((item) => {
      //     if (item && item._id == id){
      //         this.model = item;
      //     }
      // })
    } else {
      this.model.msgdatas = [{ title: '', description: [] }];
    }
  }

  add() {
    if (!this.model.name) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Tên không được bỏ trống !',
      };
    } else {
      const payload = {
        msgdesc: this.model.msgdatas,
        desc: this.model.desc,
        name: this.model.name,
        maxscore: this.model.maxscore,
        criteriaGroup: this.model.criteriaGroup,
      };
      this.cqService.create(payload).subscribe(
        res => {
          if (res) {
            const error = res.error;
            if (error) {
              this.message = {
                class: 'alert dark alert-danger',
                content: 'Thêm mới không thành công',
              };
              this.toastr.error('Thêm mới thất bại', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              this.message = {
                class: 'alert dark alert-success',
                content: 'Thêm mới thành công',
              };
              this.toastr.success('Thêm mới thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });

              this.loadData();
              this.modalRef.hide();
            }
          }
        },
        error => {
          this.message = {
            class: 'alert dark alert-danger',
            content: error.message,
          };
        }
      );
    }
  }

  edit(data) {
    this.message = null;
    if (!this.model.name) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Tên không được bỏ trống !',
      };
    } else {
      const payload = {};
      if (this.model.criteriaGroup) {
        payload['criteriaGroup'] = this.model.criteriaGroup;
      }
      if (this.model.name) {
        payload['name'] = this.model.name;
      }
      if (this.model.msgdatas) {
        payload['msgdesc'] = this.model.msgdatas;
      }
      if (this.model.desc) {
        payload['desc'] = this.model.desc;
      }
      if (this.model.maxscore) {
        payload['maxscore'] = this.model.maxscore;
      }
      this.cqService.update(this.model.id, payload).subscribe(
        res => {
          if (res) {
            const error = res.error;
            if (error) {
              this.message = {
                class: 'alert dark alert-danger',
                content: 'Cập nhật không thành công',
              };
              this.toastr.error('Cập nhật thất bại', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              this.message = {
                class: 'alert dark alert-success',
                content: 'Cập nhật thành công',
              };
              this.toastr.success('Cập nhật thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              this.loadData();
              this.modalRef.hide();
            }
          }
        },
        error => {
          this.message = {
            class: 'alert dark alert-danger',
            content: error.message,
          };
        }
      );
    }

    this.scrollToTop();
  }

  openConfirmDelete(template: TemplateRef<any>, id) {
    this.id_delete = id;
    // this.modalRef2 = this.modalService.show(template);
    const y = confirm('Bạn có muốn xóa không?');
    if (y) {
      this.submitDelete();
    }
  }

  submitDelete() {
    this.cqService._delete(this.id_delete).subscribe(
      res => {
        if (res) {
          const error = res.error;
          if (error) {
            this.message = {
              class: 'alert dark alert-danger',
              content: 'Xóa không thành công',
            };
            this.toastr.error('Xóa không thành công', error.message, {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            this.message = {
              class: 'alert dark alert-success',
              content: 'Xóa thành công',
            };
            this.toastr.success('Xóa thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
            this.loadData();
            // this.modalRef2.hide();
          }
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
        this.toastr.error('Xóa không thành công', error.message, {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
        // this.modalRef2.hide();
      }
    );
  }

  setPage(page: number) {
    if (page <= this.totalPage) {
      if (page < 1) {
        page = 1;
      }
      if (page != this.currentPage) {
        this.currentPage = page;
        this.loadData();
      }
    } else {
      page = this.totalPage;
      $('#inputPage').val(page);
      this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      if (page <= this.totalPage) {
        // this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page < 1) {
          page = 1;
        }
        if (page != this.currentPage) {
          this.currentPage = page;
          this.loadData();
        }
      }
    }
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  updateScorecriteria(data, ind) {
    this.model.msgdatas.value.map((val, index) => {
      if (index == ind) {
        val.updating = true;
      }
      return val;
    });
    this.answerValue = this.model.msgdatas.value.find((items, index) => index == ind).value;
  }

  delecriteria(data, ind) {
    if (this.model.msgdatas.value.length >= 1) {
      this.model.msgdatas.value = this.model.msgdatas.value.filter((val, index) => ind !== index);
    }
  }

  addOptionAns(i) {
    let checking = true;
    this.model.msgdatas.value.map(val => {
      if (val.updating) {
        checking = false;
      }
    });
    if (checking) {
      this.model.msgdatas.value.push({ value: '', updating: true });
    }
  }

  saveDescriptions(data, ind) {
    if (this.tileValue) {
      this.model.msgdatas.map((val, index) => {
        if (index == ind) {
          val.value = this.tileValue;
          val.updating = false;
        }
        return val;
      });
      this.tileValue = '';
    }
  }

  addDescriptions(index) {
    this.model.msgdatas.push({ title: '', description: [] });
    console.log(this.model.msgdatas, 'is model');
  }

  addSubDescripts(data) {
    this.model.msgdatas.map(value => {
      if (value.title == data.title) {
        value.description.push({ value: '' });
      }
    });
  }

  handleDeleteDesc(index) {
    this.model.msgdatas = this.model.msgdatas.filter((val, ind) => ind !== index);
  }

  handleDeleteSubDesc(ind, chilind) {
    this.model.msgdatas.map((val, index) => {
      if (index == ind) {
        val.description = val.description.filter((val, inde) => inde !== chilind);
      }
      return val;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/cq_criteria/cq_criteria.component.ts